// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import {
  IContactUsWebpage,
  IContactUsWebpageGetAttrs,
  IContactUsWebpageApiResponse,
  ISubmitContactUsAttrs,
} from 'interfaces/webpage/contact-us'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_baseResponseWebpage } from 'models/extensions/with-helper'

const ContactUsWebpageStore = types
  .model('ContactUsWebpage')
  .props({
    contactUsWebpage_isLoading: types.optional(types.boolean, false),
    contactUsWebpage_webpage: withHelper_baseResponseWebpage(),
  })
  .actions(self => ({
    contactUsWebpage_SET_LOADING: (payload: boolean): void => {
      self.contactUsWebpage_isLoading = payload
    },
    contactUsWebpage_SET_CONTACT_US_WEBPAGE: (payload: IContactUsWebpage): void => {
      self.contactUsWebpage_webpage = cast(payload)
    },
    contactUsWebpage_CLEAR_CONTACT_US_WEBPAGE: (): void => {
      self.contactUsWebpage_webpage = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch contact us webpage
     *
     * @param {IContactUsWebpageGetAttrs} payload
     *
     * @return {any} any
     */
    contactUsWebpage_fetchContactUsWebpage: flow(function* (payload: IContactUsWebpageGetAttrs) {
      self.contactUsWebpage_SET_LOADING(true)

      const response: IContactUsWebpageApiResponse = yield self.environment.contactUsWebpageApi.contactUsWebpage_getContactUs(
        payload,
      )

      if (response.ok) self.contactUsWebpage_SET_CONTACT_US_WEBPAGE(response.res.data)
      self.contactUsWebpage_SET_LOADING(false)
    }),
    /**
     * @description Send contact us form webpage
     *
     * @return {any} any
     */
    contactUsWebpage_sendContactUsFormWebpage: flow(function* (payload: ISubmitContactUsAttrs) {
      self.contactUsWebpage_SET_LOADING(true)
      const response: IContactUsWebpageApiResponse =
        yield self.environment.contactUsWebpageApi.contactUsWebpage_postContactUsForm({
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
        })
      if (response.ok) {
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.contactUsWebpage_SET_LOADING(false)
    }),
  }))

export const createContactUsWebpageStoreDefaultModel = () => types.optional(ContactUsWebpageStore, {})
